import * as yup from "yup";

export const registerSchema = yup.object().shape({
  email: yup
    .string()
    .email("Proszę podać prawidłowy adres email.")
    .required("Proszę podać adres email."),
  password: yup
    .string()
    .min(6, "Hasło musi zawierać min 6 znaków.")
    .max(128, "Hasło musi zawierać max 128 znaków.")
    .required("Proszę podać hasło."),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref("password")], "Hasło musi pasować."),
  agreements: yup.boolean().oneOf([true], "Proszę zaakceptować regulamin."),
});
